/* eslint-disable camelcase */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
import axios from 'axios';

// import { Controller } from '@context';
// import { CustomerState } from '@state';
// import { fetchTax } from './fetch-tax';
// import { ItemizedLineItem } from '@rta/rta-blueprint-library';
// import { type } from 'os';

export type GetRenderingParams = {
	// controller: Controller,
	// customer: CustomerState,
	// dealId: string,
	image: string,
	prompt: string;
	n: string;
	output_format: string;
	quality: string;
	response_format: string;
	size: string;
	getToken: () => Promise<string>,
	setError?: (error: string) => void
};

export const getRendering = async (params: GetRenderingParams): Promise<[string | null, string | null]> => {
	// eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
	const { image, prompt, n, output_format, quality, response_format, size, getToken, setError = (e) => {} } = params;

	// const kitchenData = controller?.kitchen ?? null;
	// console.log('getRendering:image', image);
	const query = {
		image,
		prompt,
		n,
		output_format,
		quality,
		response_format,
		size
	};
	try {
		const token = await getToken();
		const response = await axios.post(`${import.meta.env.VITE_API_URL}/create/rendering`, query, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		if (response.status === 200) {
			// if (setQuoteId) setQuoteId(response.data);
			// kitchenData.quoteId = response.data;
			return [response.data ?? null, null];
		}

		throw new Error('Error rendering image');
	} catch (error) {
		if (setError) setError('Error rendering image');
		return [null, 'Error rendering image'];
	}

	return [null, null];
};
